import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import question from '../../assets/images/question.png';
import './How.css';

const reasonsLeft = [
    { num: "01", text: "Investing in one of the best research community" },
    { num: "02", text: "Networking with the best resource people" },
    { num: "03", text: "Chance to contribute for the growing research programs around the world and gain recognition" },
    { num: "04", text: "Open Access to multiple resources and data sets" },
    { num: "05", text: "Career growth" }
];

const reasonsRight = [
    { num: "06", text: "Personal development" },
    { num: "07", text: "Exposure to multi-disciplinary perspectives" },
    { num: "08", text: "Access to mentorship and guidance" },
    { num: "09", text: "Contribute to societal progress" },
    { num: "10", text: "Collaborative research and global scientific impact" }
];

const How = () => {
    return (
        <section className="cb-why-section" id="why">
            <div className="cb-why-glow"></div>
            <div className="container">
                <div className="cb-section-title-wrap">
                    <div className="cb-studio-tag">[ 03 // VALUE PROPOSITION ]</div>
                    <h2 className="cb-section-title">
                        Why Us?
                    </h2>
                </div>

                <div className="cb-why-tri-layout">
                    <div className="cb-why-col cb-why-left-col">
                        {reasonsLeft.map((item) => (
                            <div key={item.num} className="cb-why-item">
                                <span className="cb-why-num">[{item.num}]</span>
                                <CheckCircle2 size={18} strokeWidth={2.4} className="cb-why-check-icon" />
                                <span className="cb-why-text">{item.text}</span>
                            </div>
                        ))}
                    </div>

                    <div className="cb-why-center-card">
                        <div className="cb-why-card-glow" aria-hidden="true"></div>
                        <img src={question} alt="Why ChemBioAI" className="cb-why-img" />
                    </div>

                    <div className="cb-why-col cb-why-right-col">
                        {reasonsRight.map((item) => (
                            <div key={item.num} className="cb-why-item">
                                <span className="cb-why-num">[{item.num}]</span>
                                <CheckCircle2 size={18} strokeWidth={2.4} className="cb-why-check-icon" />
                                <span className="cb-why-text">{item.text}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default How;